export default __webpack_public_path__ + "static/media/HVCarpets_LoginPage.5b03ffec.jpeg";